import { useEffect, useState } from "react";

export const useLocalState = (key: string, initial: string) => {
  const [value, setValue] = useState(() => {
    // eslint-disable-next-line no-undef
    if (typeof window !== undefined && window.localStorage) {
      // eslint-disable-next-line no-undef
      const saved = window.localStorage.getItem(key);

      if (null == saved) return initial;

      if (saved) {
        try {
          return JSON.parse(saved);
        } catch (e) {
          return initial;
        }
      }
    }
    return initial;
  });

  useEffect(() => {
    // eslint-disable-next-line no-undef
    if (window.localStorage) {
      // eslint-disable-next-line no-undef
      window.localStorage.setItem(key, JSON.stringify(value));
    }
  }, [key, value]);

  return [value, setValue];
};
